module.exports = __webpack_public_path__ + "pnskfsquadron/img/ja-slider-6.jpg?46299ae3";